export default {
  title: 'Badge',
  actions: {
    create: 'créer un badge',
    add: 'ajouter un badge',
    'add-new': 'Ajouter un autre badge',
    'link-event': 'Lier un événement',
    'add-child': 'badge enfant',
    'check-child-badge': 'Vérifiez le(s) action(s) des badge(s) enfant(s).',
    'check-infos': 'Pour rendre ce badge débloquable, il faut',
    'badge-unblockable': 'En déclanchant les événement(s) suivante',
    'badge-unblockable-children': 'En débloquant chaque badge enfant.',
    'see': 'voir les badges',
    'hide': 'cacher les badges'
  },
  empty: {
    title: 'Aucun badge',
    message: 'Pour créer un badge, rien de plus simple, il suffit de cliquer sur le lien suivant :'
  },
  state: {
    published: 'publié',
    testing: 'en test',
    terminated: 'terminé',
    unlockable: 'Débloquable',
    lockable: 'Non Débloquable',
    publishedAll: 'badges publiés!',
    blockedWarning: 'Les badges suivants ont été publiés, mais ils sont toujours non débloquable. ('
  },
  modal: {
    fields: {
      name: 'Nom',
      maxachieved: 'Restreindre le nombre de badge',
      period: 'Restreindre la période',
      date: {
        start: 'Début',
        end: 'Fin'
      }
    },
    create: {
      title: 'Créer un badge'
    },
    edit: {
      title: 'Editer un badge'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/badge.js